<template>
  <div></div>
</template>

<script>
import { service } from '../../app'
import { mapGetters } from 'vuex'

export default {
  data() {
    return {}
  },
  computed: {
    ...mapGetters({
      Language: 'language/code',
    }),
  },
  mounted() {
    if (Object.keys(this.$route.query).length <= 0) {
      // show error
      console.log('no query')
      this.$router.push('/' + this.Language)
      return
    }
    if (this.$route.query.t === undefined && this.$route.query.cxd === undefined) {
      // show error
      console.log('no tracking code')
      this.$router.push('/' + this.Language)
      return
    }

    // $conf['URLs']['lp-partners'] = "/partners";
    const destinationURLs = {
      register: `/${this.Language}/register/live`,
      demo: `/${this.Language}/register/demo`,
      partner: `/${this.Language}/register/partner`,
      home: `https://www.eurotrader.com/`,
      spreads: `https://www.eurotrader.com/en/markets/instruments-spreads`,
      mt4: `https://www.eurotrader.com/en/trade/metatrader-4`,
      mt5: `https://www.eurotrader.com/en/trade/metatrader-5`,
      accountTypes: `https://www.eurotrader.com/en/trade/account-types`,
      contact: `https://www.eurotrader.com/en/contact`,
    }

    let destination = destinationURLs['register']

    if (this.$route.query.dest !== undefined) {
      destination = destinationURLs[this.$route.query.dest]
    }

    if (this.$route.query.cxd !== undefined) {
      this.$createCookie('cx_token', this.$route.query.cxd, 14)
    }
    if (this.$route.query.affid !== undefined) {
      this.$createCookie('aff_id', this.$route.query.affid, 14)
    }

    // set cookie
    if (this.$route.query.t !== undefined) {
      this.$createCookie('refcode', this.$route.query.t, 30)

      // ajax store action
      service.get('/ib/add-visit', {
        params: {
          code: this.$route.query.t,
        },
      })
    }

    // redirect regardless
    window.location = destination
  },
}
</script>



// WEBPACK FOOTER //
// TrackingLinkRedirector.vue?5dcce206